/**
 * Composites an image onto a white canvas so transparent PNG/WebP/GIF
 * pixels become opaque white (WhatsApp-like). Non-image files and JPEGs
 * are returned unchanged. Falls back to the original file on failure.
 */
export async function flattenImageOntoWhite(file) {
  if (!file?.type?.startsWith('image/')) return file;
  // JPEG has no alpha — skip unnecessary re-encode
  if (file.type === 'image/jpeg' || file.type === 'image/jpg') return file;

  try {
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bitmap.close();
      return file;
    }

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close();

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, 'image/png');
    });

    if (!blob) return file;

    const baseName = file.name.replace(/\.[^/.]+$/, '') || 'image';
    return new File([blob], `${baseName}.png`, {
      type: 'image/png',
      lastModified: Date.now(),
    });
  } catch (err) {
    console.warn('Failed to flatten image onto white:', err);
    return file;
  }
}
